import React from 'react';

import Router from 'next/router';
import {
  Modal,
  // $FlowFixMe
} from '@bijie/react-bnb';

import { AUTH_TYPE } from '../../config/constantNg';
import { gwPost } from '../actionsFactory/gwRequest';
import createBaseActions, { setPostBody } from '../actionsFactory';
import API_PATH from '../actionsFactory/apiPath';
import actionTypes from '../actionsFactory/types';
import { createCookie, eraseCookie } from '../../utils/cookies-browser';
import { getLabel } from '../../utils/i18n';
import { getUrlParam, getLoginUrl, checkCallback } from '../../utils/urlUtils';
import wfp from '../../utils/wfp';

const { BOTH, GOOGLE, SMS } = AUTH_TYPE;

const { USER_STATE_LOGGED_OUT, USER_STATE_LOGGED_IN } = actionTypes;

const { LOGIN_API_PATH, USER_LOGIN_OUT_API } = API_PATH;

const getCallback = (url, referer) => {
  if (!checkCallback(url)) {
    return '';
  }
  return referer ? `${url}&zendesk=${referer}` : url;
};

export const userLoggedOut = createBaseActions(USER_STATE_LOGGED_OUT);
export const userLoggedIn = createBaseActions(USER_STATE_LOGGED_IN);

export const Logout = async (ev, locale) => {
  ev && ev.preventDefault();
  const result = await gwPost(USER_LOGIN_OUT_API);
  if (result.success) {
    eraseCookie('logined');
    eraseCookie('cr00');
    eraseCookie('JSESSIONID');
    eraseCookie('p20t');
    eraseCookie('mobile');
    Router.push(getLoginUrl(locale));
  }
};

const _loginCallback = (res, email, locale, i18n, dispatch) => {
  const {
    success, data, message, code,
  } = res;
  const callbackUrl = getUrlParam('callback');
  const callbackReferer = getUrlParam('zendesk');
  const callback = callbackUrl ? getCallback(callbackUrl, callbackReferer) : '';

  if (success) {
    const {
      confirmTips,
      currentDeviceId,
      gauth,
      mobileSecurity,
      securityKey,
      disable,
      mobile,
    } = data;
    if (disable) {
      Modal.confirm({
        icon: <img src={require('../../static/images/2fa/account-frozen.svg')} alt="account frozen" />,
        content: <p>{getLabel('exchange-login-accountDisable', i18n)}</p>,
        onOk: () => {
          window.location.href = `/${locale}/reset2fa/enable`;
        },
        cancelText: `${getLabel('exchange-common-cancel', i18n)}`,
        okText: getLabel('exchange-login-unlock', i18n),
      });
      return;
    }

    let authType = '';
    if (securityKey) authType = 'FIDO2';
    else if (gauth && mobileSecurity) {
      authType = BOTH;
      sessionStorage.setItem('userMobile', mobile);
    } else if (gauth && !mobileSecurity) {
      authType = GOOGLE;
    } else if (!gauth && mobileSecurity) {
      authType = SMS;
      sessionStorage.setItem('userMobile', mobile);
    }

    if (authType) {
      sessionStorage.setItem('email', email);
      Router.pushRoute(
        `/${locale}/authenticate/${authType}${callback ? `?callback=${callback}` : ''}`
      );
      return;
    }
    createCookie('logined', 'y', 7);
    createCookie('isOurUser', 'y');
    dispatch(userLoggedIn());
    wfp.saveCurrentDeviceId(email, currentDeviceId || '');
    if (callback && confirmTips) {
      localStorage.setItem('hasFillSecurityResearch', 'true');
      window.location.href = callback;
      return;
    }
    if (!callback && confirmTips) {
      localStorage.setItem('hasFillSecurityResearch', 'true');
      Router.push(`/${locale}/usercenter/dashboard/overview`);
      return;
    }
    if (callback && !confirmTips) {
      localStorage.setItem('hasFillSecurityResearch', 'false');
      // window.location.href = `/safetyInstructions.html?callback=${callback}`;
      Router.pushRoute(`/${locale}/quiz`);
      return;
    }
    if (!callback && !confirmTips) {
      localStorage.setItem('hasFillSecurityResearch', 'false');
      // window.location.href = '/safetyInstructions.html';
      Router.pushRoute(`/${locale}/quiz`);
      return;
    }
  }
  if (code === '200001005') {
    sessionStorage.setItem('registerEmail', email);
    Router.pushRoute(`/${locale}/email-verification`);
    return;
  }

  if (code === '006007') {
    Router.pushRoute(`/${locale}/login`);
    return;
  }

  if (code === '200002040') {
    return;
  }

  Modal.info({
    icon: <img src={require('./error.svg')} width="78" alt="error" />,
    content: <p>{message}</p>,
    okText: getLabel('exchange-modal-iUnderstood', i18n),
  });
};

export const login = formData => async (dispatch, getState) => {
  const { locale, localeData } = getState();
  const i18n = localeData[locale];
  try {
    const { email } = formData;
    const params = setPostBody(formData);
    const result = await gwPost(LOGIN_API_PATH, { locale, ...params }, null, false);
    _loginCallback(result, email, locale, i18n, dispatch);
    return result;
  } catch (error) {
    throw error;
  }
};

export const verifyToken = () => async dispatch => {
  let isLogined = false;
  try {
    const data = await gwPost(
      API_PATH.USER_VERIFY_TOKEN,
      { ...setPostBody() },
      null,
      true,
      {
        withClientApiCache: true,
        isExpiredFromResponse: true,
      }
    );
    if (!data.success) throw new Error();
    isLogined = true;
    dispatch({ type: USER_STATE_LOGGED_IN });
  } catch (error) {
    dispatch({ type: USER_STATE_LOGGED_OUT });
    eraseCookie('logined');
  }
  return isLogined;
};
export default Logout;
